<template>
  <utd-pill-button class="translate-button"
                   button-style="pill"
                   button-icon="repeat"
                   size="small"
                   @click="toggleTranslatedFeatureResult">
    <span>Translate</span>
  </utd-pill-button>
</template>
<script>
import UtdPillButton from '_acaSrc/components/shared/stdlib/UtdPillButton.vue';
import PubSub from '_acaSrc/utility/PubSub';
import { C_EVENTS } from '_acaSrc/utility/constants';
import { getWindow } from '_acaSrc/utility/DOM';

export default {
    components: {
        UtdPillButton
    },
    emits: [ 'translate-button-click' ],
    methods: {
        toggleTranslatedFeatureResult() {
            new PubSub().publish(C_EVENTS.TRANSLATE_FEATURED_SEARCH_RESULT);
            new PubSub().publish(C_EVENTS.TRACK_UI_CLICK_EVENT, {
                targetUrl: getWindow().location.href,
                uiElementName: 'panelTranslateButton'
            });
            this.$emit('translate-button-click');
        }
    }
};
</script>

<style lang="less" scoped>
@import '~_acaAssets/wkce/colors/wkce-app-styles';

.translate-button {
  .ds1-utd-weight-600();
  .ds1-mt-compact();
  margin-left: 12px;
  display: none;
  background-color: @DS1-PILL-HOVER-BACKGROUND-COLOR;

  &:hover {
    background-color: @WKCE-BLUE-SHADE1;
    color: @WKCE-WHITE;
  }
}
</style>